const n = {
  translations: {
    archiveNotification: "Archive this notification",
    archiveRead: "Archive Read",
    markAllAsRead: "Mark all as read",
    notifications: "Notifications",
    emptyFeedTitle: "No notifications yet",
    emptyFeedBody: "We'll let you know when we've got something new for you.",
    all: "All",
    unread: "Unread",
    read: "Read",
    unseen: "Unseen",
    slackConnectChannel: "Connect channel",
    slackChannelId: "Slack channel ID",
    slackConnecting: "Connecting to Slack...",
    slackDisconnecting: "Disconnecting...",
    slackConnect: "Connect to Slack",
    slackConnected: "Connected",
    slackConnectContainerDescription: "Connect to get notifications in your Slack workspace.",
    slackSearchbarDisconnected: "Slack is not connected.",
    slackSearchbarMultipleChannels: "Multiple channels connected",
    slackSearchbarNoChannelsConnected: "Search channels",
    slackSearchbarNoChannelsFound: "No slack channels.",
    slackSearchbarChannelsError: "Error fetching channels.",
    slackSearchChannels: "Search channels",
    slackConnectionErrorExists: "Try reconnecting to Slack to find and select channels from your workspace.",
    slackConnectionErrorOccurred: "There was an error connecting to Slack. Try reconnecting to find and select channels from your workspace.",
    slackChannelAlreadyConnected: "Error: already connected",
    slackError: "Error",
    slackDisconnect: "Disconnect",
    slackChannelSetError: "Error setting channel.",
    slackAccessTokenNotSet: "Access token not set.",
    slackReconnect: "Reconnect"
  },
  locale: "en"
};
export {
  n as default
};
//# sourceMappingURL=en.mjs.map
